import { ISearchConfig } from '@/components/page-search/types'

export const searchFormConfig: ISearchConfig = {
  formItems: [
    {
      type: 'input',
      label: '学生姓名',
      placeholder: '请输入学生姓名',
      field: 'studentName'
    },
    {
      type: 'input',
      label: '联系电话',
      placeholder: '请输入联系电话',
      field: 'phone'
    }
  ]
} 